import { Component, OnInit, AfterViewInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
declare var $: any;

@Component({
    templateUrl:"./reports.component.html"
})
export class ReportsComponent implements OnInit, AfterViewInit{
    public pageTitle: string = 'Reports';
    constructor(private authService: AuthService, private appCommonService: AppCommonService, public headerAndNavigationService: HeaderAndNavigationService) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;
    }    
    ngOnInit(): void {
      this.headerAndNavigationService.showhideNav(false, true);
    }

    ngAfterViewInit(): void {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts